import { useState } from "react";

import { IntegrationLayoutEntry } from "@common/models/integrations";

const useIntegrationLayout = (initialLayout: IntegrationLayoutEntry[]) => {
  const [integrationLayout, setIntegrationLayout] = useState<IntegrationLayoutEntry[]>(initialLayout);

  const moveIntegrationLayoutEntryUp = (index: number) => {
    if (index === 0) return;

    const updated = [...integrationLayout];
    const temp = updated[index - 1];
    updated[index - 1] = updated[index];
    updated[index] = temp;

    setIntegrationLayout(updated);
  };

  const moveIntegrationLayoutEntryDown = (index: number) => {
    if (index === integrationLayout.length - 1) return;

    const updated = [...integrationLayout];
    const temp = updated[index + 1];
    updated[index + 1] = updated[index];
    updated[index] = temp;

    setIntegrationLayout(updated);
  };

  const toggleIntegrationLayoutEntry = (index: number) => {
    const updated = [...integrationLayout];
    updated[index] = { ...updated[index], enabled: !updated[index].enabled };

    setIntegrationLayout(updated);
  };

  return {
    integrationLayout,
    moveIntegrationLayoutEntryUp,
    moveIntegrationLayoutEntryDown,
    toggleIntegrationLayoutEntry,
    setIntegrationLayout,
  };
};

export { useIntegrationLayout };
